import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { connectIntegration } from "./../services/shopify.js";

import ShopifyLogo from "./../imgs/shopify-small-logo.png";

import {

    ShieldCheck,
    Zap,
    Code2,
    CheckCircle2,
    ArrowRight

} from "lucide-react";

export function SetupShopify() {

    const [shop, setShop] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {

        const installation = localStorage.getItem(

            "shopifyInstallation"

        );

        console.log('installation: ', installation);

        if (installation) {

            setShop(

                JSON.parse(installation)

            );

        }

    }, []);

    async function handleInstall() {
        localStorage.setItem(
            "shopifyFlow",
            "onboarding"
        );

        window.location.href = "https://apps.shopify.com";

    }

    async function handleContinue() {

        try {

            const installation = JSON.parse(

                localStorage.getItem(

                    "shopifyInstallation"

                )

            );

            const outletUid = localStorage.getItem(

                "onboardingOutletUid"

            );

            console.log("integrationUid: ", installation.integrationUid);
            console.log("outletUid: ", outletUid);
            await connectIntegration({

                integrationUid: installation.integrationUid,

                outletUid: outletUid,

            });

            localStorage.setItem(
                "selectedOutletUid",
                outletUid
            )

            //--------------------------------------------------
            // Cleanup
            //--------------------------------------------------

            localStorage.removeItem(

                "shopifyInstallation"

            );

            localStorage.removeItem(

                "onboardingOutletUid"

            );

            localStorage.removeItem(

                "shopifyFlow"

            );

            //--------------------------------------------------
            // Go to dashboard
            //--------------------------------------------------

            navigate(

                "/overview"

            );

        }

        catch (error) {

            console.error(error);

            alert(

                "Failed to connect Shopify."

            );

        }

    }

    return (

        <>

            <header className="setup-header">

                <div className="setup-header-logo">

                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="NextGo Logo"
                        className="setup-header-logo-icon"
                    />

                    <span className="setup-header-logo-text">
                        Next<span className="blue">Go</span>
                    </span>

                </div>

            </header>

            <main className="setup-shopify-page">

                <div className="setup-shopify-card">

                    <div className="shopify-logo">

                        <img

                            src={ShopifyLogo}

                            alt="Shopify"

                        />

                    </div>

                    {

                        !shop &&

                        <>

                            <h1>

                                Connect your Shopify Store

                            </h1>

                            <p className="subtitle">

                                Install the NextGo Shopify app to display
                                personalized partner offers on your
                                order status (Thank You) page.

                            </p>

                            <div className="benefits">

                                <div className="benefit">

                                    <ShieldCheck size={20} />

                                    <span>

                                        Secure OAuth authentication

                                    </span>

                                </div>

                                <div className="benefit">

                                    <Zap size={20} />

                                    <span>

                                        Takes less than one minute

                                    </span>

                                </div>

                                <div className="benefit">

                                    <Code2 size={20} />

                                    <span>

                                        No coding required

                                    </span>

                                </div>

                            </div>

                            <button

                                className="primary-button"

                                onClick={handleInstall}

                            >

                                Install NextGo App

                            </button>

                        </>

                    }

                    {

                        shop &&

                        <>

                            <div className="success-icon">

                                <CheckCircle2

                                    size={64}

                                />

                            </div>

                            <h1>

                                Shopify Connected

                            </h1>

                            <p className="subtitle">

                                Your Shopify store has been connected
                                successfully.

                            </p>

                            <div className="connected-store">

                                <h3>

                                    Connected Store

                                </h3>

                                <p>

                                    {shop.shopName}

                                </p>

                                <span>

                                    {shop.shopDomain}

                                </span>

                            </div>

                            <button

                                className="primary-button"

                                onClick={handleContinue}

                            >

                                Continue

                                <ArrowRight

                                    size={18}

                                />

                            </button>

                        </>

                    }

                </div>

            </main>

        </>

    );

}